import {
  Users,
  Building2,
  MessageCircle,
  Phone,
  Mail,
  MessageSquare,
  Rocket,
  X,
  Sparkles,
  ThumbsUp,
  Heart,
  Award,
  Target,
  Clock,
  Calendar,
  TrendingUp,
  Zap,
  Brain,
  Lightbulb,
  CheckCircle2,
  AlertCircle,
  Info,
  HelpCircle,
  Smartphone,
  Hand,
  User,
  Volume2,
  Wrench,
} from 'lucide-react';

/**
 * Icon mapping for wizard choice options
 * Maps emoji or string identifiers to React icon components
 */
export const iconMap: Record<string, React.ReactNode> = {
  // Communication frameworks
  '👥': <Users className="w-5 h-5" />,
  '🏢': <Building2 className="w-5 h-5" />,
  '💬': <MessageCircle className="w-5 h-5" />,
  '📞': <Phone className="w-5 h-5" />,
  '📧': <Mail className="w-5 h-5" />,
  '📱': <Smartphone className="w-5 h-5" />,
  '💭': <MessageSquare className="w-5 h-5" />,
  '🚀': <Rocket className="w-5 h-5" />,
  '❌': <X className="w-5 h-5" />,

  // Positive effects
  '✨': <Sparkles className="w-5 h-5" />,
  '👍': <ThumbsUp className="w-5 h-5" />,
  '❤️': <Heart className="w-5 h-5" />,
  '🏆': <Award className="w-5 h-5" />,
  '🎯': <Target className="w-5 h-5" />,
  '⏰': <Clock className="w-5 h-5" />,
  '📅': <Calendar className="w-5 h-5" />,
  '📈': <TrendingUp className="w-5 h-5" />,
  '⚡': <Zap className="w-5 h-5" />,
  '🧠': <Brain className="w-5 h-5" />,
  '💡': <Lightbulb className="w-5 h-5" />,
  '✅': <CheckCircle2 className="w-5 h-5" />,
  '⚠️': <AlertCircle className="w-5 h-5" />,
  ℹ️: <Info className="w-5 h-5" />,
  '❓': <HelpCircle className="w-5 h-5" />,
  '👋': <Hand className="w-5 h-5" />,
  '👤': <User className="w-5 h-5" />,
  '🔊': <Volume2 className="w-5 h-5" />,
  '🔧': <Wrench className="w-5 h-5" />,

  // String identifiers (for more control)
  'one-on-one': <Users className="w-5 h-5" />,
  meeting: <Building2 className="w-5 h-5" />,
  'casual-conversation': <MessageCircle className="w-5 h-5" />,
  'phone-call': <Phone className="w-5 h-5" />,
  email: <Mail className="w-5 h-5" />,
  'instant-message': <MessageSquare className="w-5 h-5" />,
  'solve-platform': <Rocket className="w-5 h-5" />,
  'not-relevant': <X className="w-5 h-5" />,

  // Effects
  energizes: <Zap className="w-5 h-5" />,
  confidence: <ThumbsUp className="w-5 h-5" />,
  connected: <Heart className="w-5 h-5" />,
  reputation: <Award className="w-5 h-5" />,
  meaningful: <Target className="w-5 h-5" />,
  belonging: <Users className="w-5 h-5" />,
  responsibility: <CheckCircle2 className="w-5 h-5" />,
  learning: <Brain className="w-5 h-5" />,
  growth: <TrendingUp className="w-5 h-5" />,
  none: <X className="w-5 h-5" />,
};

/**
 * Get icon component from emoji or string identifier
 */
export const getIconForOption = (
  iconIdentifier?: string | React.ReactNode
): React.ReactNode => {
  if (!iconIdentifier) return null;

  // If it's already a React node, return it
  if (typeof iconIdentifier !== 'string') {
    return iconIdentifier;
  }

  // Look up in icon map
  return iconMap[iconIdentifier] || null;
};
